import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../interfaces/address';
import { Person } from '../interfaces/person';

/**
 * Gibt den kompletten Namen (Vorname + Nachname) des Kunden aus
 */
@Pipe({name: 'city' })
export class CityPipe implements PipeTransform {
  transform(value: Address): string {
    return `${value.ZipCode} ${value.City}`;
  }
}